import jsQR from "jsqr";

/**
 * Try to read a QR code from ImageData (e.g. from a video frame). Returns the decoded string or null.
 */
export function readQrFromImageData(
  data: Uint8ClampedArray,
  width: number,
  height: number
): string | null {
  const code = jsQR(data, width, height);
  return code ? code.data : null;
}

/**
 * Try to read a QR code from an image data URL. Returns the decoded URL or null.
 */
export function readQrFromDataUrl(dataUri: string): Promise<string | null> {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        resolve(null);
        return;
      }
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const code = jsQR(imageData.data, imageData.width, imageData.height);
      resolve(code ? code.data : null);
    };
    img.onerror = () => resolve(null);
    img.src = dataUri;
  });
}
